module.exports = __webpack_public_path__ + "img/13_33.d1660b7a.png";